"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useRef, useState } from "react";
import { Box, chakra, Drawer, IconButton, Portal } from "@chakra-ui/react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
const AngleLeft = chakra(FaAngleLeft);
const AngleRight = chakra(FaAngleRight);

// The drawer's mobile height, as a Chakra token and as the equivalent ratio
// used for the map's bottom padding. Keep the two in sync.
export const MOBILE_DRAWER_HEIGHT = "1/2" as const;
export const MOBILE_DRAWER_HEIGHT_RATIO = 0.5;
interface DrawerProps {
  children: React.ReactNode;
  title: string;
  footerText: React.ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}
const SHDrawer = t0 => {
  const $ = _c(15);
  const {
    children,
    title,
    footerText,
    open,
    onOpenChange
  } = t0;
  const drawerContainerRef = useRef(null);
  const [drawerContainer, setDrawerContainer] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = node => {
      drawerContainerRef.current = node;
      setDrawerContainer(node);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const setContainer = t1;
  let t2;
  if ($[1] !== drawerContainer || $[2] !== onOpenChange || $[3] !== open) {
    t2 = drawerContainer && !open && <Portal container={drawerContainerRef}><Box position="absolute" zIndex="overlay" top={{
        base: "auto",
        md: "0"
      }} left="0" bottom="0" right={{
        base: "0",
        md: "auto"
      }} w={{
        base: "auto",
        md: "5"
      }} h={{
        base: "5",
        md: "auto"
      }} backgroundColor="white"><Box onClick={() => onOpenChange(true)} asChild={true} position="absolute" left={{
          base: "0",
          md: "0"
        }} right={{
          base: "0",
          md: "auto"
        }} bottom={{
          base: "0",
          md: "auto"
        }} top={{
          base: "auto",
          md: "1/2"
        }} w={{
          base: "fit",
          md: "auto"
        }} mx={{
          base: "auto",
          md: "0"
        }} transform={{
          base: "none",
          md: "translateY(-50%)"
        }}><IconButton aria-label="Open risk layers" variant="subtle" rounded="full" size="md"><AngleRight rotate={{
              base: "270deg",
              md: "0deg"
            }} /></IconButton></Box></Box></Portal>;
    $[1] = drawerContainer;
    $[2] = onOpenChange;
    $[3] = open;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== drawerContainer || $[7] !== footerText || $[8] !== onOpenChange || $[9] !== open || $[10] !== title) {
    t3 = drawerContainer && <Drawer.Root placement={{
      mdDown: "bottom",
      md: "start"
    }} open={open} onOpenChange={details => onOpenChange(details.open)} modal={false} closeOnInteractOutside={false} lazyMount={true}><Portal container={drawerContainerRef}><Drawer.Positioner h="full" w="full" position="absolute" pointerEvents="none"><Drawer.Content w={{
            base: "full",
            md: "sm"
          }} maxW={{
            base: "full",
            md: "sm"
          }} h={{
            base: MOBILE_DRAWER_HEIGHT,
            md: "full"
          }} maxH={{
            base: MOBILE_DRAWER_HEIGHT,
            md: "full"
          }} pointerEvents="auto" css={{
            "&[data-state='open']": {
              animationName: "none"
            }
          }}><Drawer.CloseTrigger asChild={true} position="absolute" left={{
              base: "0",
              md: "auto"
            }} right={{
              base: "0",
              md: "-5"
            }} top={{
              base: "-5",
              md: "1/2"
            }} w={{
              base: "fit",
              md: "auto"
            }} mx={{
              base: "auto",
              md: "0"
            }} transform={{
              base: "none",
              md: "translateY(-50%)"
            }}><IconButton aria-label="Close risk layers" variant="subtle" rounded="full" size="md"><AngleLeft rotate={{
                  base: "270deg",
                  md: "0deg"
                }} /></IconButton></Drawer.CloseTrigger><Drawer.Header><Drawer.Title>{title}</Drawer.Title></Drawer.Header><Drawer.Body>{children}</Drawer.Body><Drawer.Footer>{footerText}</Drawer.Footer></Drawer.Content></Drawer.Positioner></Portal></Drawer.Root>;
    $[5] = children;
    $[6] = drawerContainer;
    $[7] = footerText;
    $[8] = onOpenChange;
    $[9] = open;
    $[10] = title;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <Box ref={setContainer}><>{t2}{t3}</></Box>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
export default SHDrawer;